<template>
	<div class="repair-detail-container">
		<!-- 访问码验证部分 -->
		<div v-if="!accessGranted" class="access-code-form">
			<h2>请输入访问码</h2>
			<input v-model="accessCode" type="password" placeholder="请输入工程师访问码" class="code-input" />
			<button @click="verifyAccessCode" class="verify-btn">验证</button>
			<p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
		</div>

		<!-- 报修详情部分 -->
		<div v-else class="repair-detail">
			<h2 class="repair-title">工单详情</h2>

			<div class="detail-card">
				<div class="detail-row">
					<span class="detail-label">单号:</span>
					<span class="detail-value">{{ repairData.service_no }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">提交时间:</span>
					<span class="detail-value">{{ repairData.created_at }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">公司名称:</span>
					<span class="detail-value">{{ repairData.company_id }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">联系人:</span>
					<span class="detail-value">{{ repairData.contact_person }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">联系电话:</span>
					<span class="detail-value">{{ repairData.contact_phone }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">电子邮箱:</span>
					<span class="detail-value">{{ repairData.email }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">职务:</span>
					<span class="detail-value">{{ repairData.job_title }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">仪器型号:</span>
					<span class="detail-value">{{ repairData.title }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">序列号:</span>
					<span class="detail-value">{{ repairData.serial_number }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">问题描述:</span>
					<span class="detail-value">{{ repairData.content }}</span>
				</div>

				<div class="detail-row">
					<span class="detail-label">状态:</span>
					<span class="detail-value status-badge"
						:class="getStatusName(repairData.status)">{{ getStatusName(repairData.status) }}</span>
				</div>
			</div>

			<!-- 附件部分 -->
			<div v-if="repairData.attachments.length > 0" class="attachments-section">
				<h3 class="section-title">相关附件</h3>
				<div class="attachment-list">
					<div v-for="(file, index) in repairData.attachments" :key="index" class="attachment-item">
						<span class="file-icon">
							<i :class="getFileIcon(file.file_type)"></i>
						</span>
						<span class="file-name">{{ file.file_name }}</span>
						<button @click="downloadFile(`https://www.fossnet.cn/api/`+file.file_path)"
							class="download-btn">下载</button>
					</div>
				</div>
			</div>

			<!-- 处理记录部分 -->
			<!-- <div v-if="processingRecords.length > 0" class="records-section">
				<h3 class="section-title">处理记录</h3>
				<div class="record-list">
					<div v-for="(record, index) in processingRecords" :key="index" class="record-item">
						<div class="record-time">{{ record.time }}</div>
						<div class="record-content">{{ record.content }}</div>
						<div class="record-operator">处理人: {{ record.operator }}</div>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import {
		apiBaseUrl
	} from '@/config';
	export default {
		data() {
			return {
				accessGranted: false,
				accessCode: '',
				errorMessage: '',
				repairData: {},
				attachments: [
					// 示例数据
					{
						name: '故障图片1.jpg',
						type: 'image',
						url: '#'
					},
					{
						name: '故障描述.docx',
						type: 'doc',
						url: '#'
					}
				],
				processingRecords: [
					// 示例数据
					{
						time: '2025/6/16 11:30:00',
						content: '已收到报修申请，正在分配工程师',
						operator: '系统管理员'
					}
				],
				id: 0,
				type: '',
				detail: {}
			}
		},
		mounted() {
			this.id = this.$route.query.id;
			this.type = this.$route.query.type;
			this.getTaskDetail()

		},
		methods: {
			getStatusName(status) {
				const map = {
					0: '待处理',
					1: '处理中',
					2: '已完成',
					3: '已取消'
				};
				return map[status] || '';
			},
			async verifyAccessCode() {
				// 这里应该调用API验证访问码
				// 示例中使用简单的验证
				const response = await fetch(`${apiBaseUrl}/getTaskCode.php`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						id: this.$route.query.id,
						type: this.$route.query.type,
						code: this.accessCode
					}),
				});

				const data = await response.json();
				if (data.code == '200') { // 实际应该使用更安全的验证方式
					this.accessGranted = true
					this.errorMessage = ''
				} else {
					this.errorMessage = '访问码错误，请重试'
				}
			},
			async getTaskDetail() {
				const response = await fetch(`${apiBaseUrl}/getTaskDetail.php`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						id: this.$route.query.id,
						type: this.$route.query.type,
					}),
				});

				const data = await response.json();
				this.repairData = data.data
			},
			getFileIcon(fileType) {
				const iconMap = {
					image: 'el-icon-picture',
					pdf: 'el-icon-document',
					doc: 'el-icon-document',
					xls: 'el-icon-document',
					ppt: 'el-icon-document',
					zip: 'el-icon-folder',
					default: 'el-icon-document'
				}
				return iconMap[fileType] || iconMap.default
			},
			async downloadFile(url) {
				try {
					// 检查是否是图片文件
					const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|mp4|avi|mov)$/i.test(url);

					if (isImage) {
						// 对于图片文件，使用fetch API获取后下载
						await this.downloadImageWithFetch(url);
					} else {
						// 其他文件使用常规下载方式
						const fileName = url.split('/').pop();
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', fileName);
						link.setAttribute('target', '_blank');
						document.body.appendChild(link);
						link.click();
						setTimeout(() => {
							document.body.removeChild(link);
						}, 100);
					}
				} catch (error) {
					console.error('下载失败:', error);
					this.$message.error('文件下载失败');
				}
			},

			async downloadImageWithFetch(url) {
				// 使用fetch获取图片数据
				const response = await fetch(url);
				if (!response.ok) {
					throw new Error('图片获取失败');
				}

				// 将响应转换为Blob
				const blob = await response.blob();

				// 创建对象URL
				const blobUrl = window.URL.createObjectURL(blob);

				// 提取文件名
				const fileName = url.split('/').pop();

				// 创建下载链接
				const link = document.createElement('a');
				link.href = blobUrl;
				link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();

				// 清理
				setTimeout(() => {
					document.body.removeChild(link);
					window.URL.revokeObjectURL(blobUrl);
				}, 100);
			}
		}
	}
</script>

<style scoped>
	.repair-detail-container {
		max-width: calc(100% - 30px);
		padding: 15px;
		font-family: 'Helvetica Neue', Arial, sans-serif;
		color: #333;
	}

	.repair-detail {
		max-width: 40%;
		margin: 0 auto;
	}

	/* 访问码表单样式 */
	.access-code-form {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 80vh;
		padding: 20px;
	}

	.access-code-form h2 {
		margin-bottom: 20px;
		color: #333;
	}

	.code-input {
		width: calc(15% - 30px);
		padding: 12px 15px;
		margin-bottom: 15px;
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 16px;
	}

	.verify-btn {
		width: 15%;
		padding: 12px;
		background-color: #409EFF;
		color: white;
		border: none;
		border-radius: 4px;
		font-size: 16px;
		cursor: pointer;
	}

	.verify-btn:hover {
		background-color: #66b1ff;
	}

	.error-message {
		color: #F56C6C;
		margin-top: 10px;
	}

	/* 报修详情样式 */
	.repair-title {
		text-align: center;
		margin-bottom: 20px;
		color: #333;
	}

	.detail-card {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
	}

	.detail-row {
		display: flex;
		padding: 10px 0;
		border-bottom: 1px solid #eee;
	}

	.detail-row:last-child {
		border-bottom: none;
	}

	.detail-label {
		flex: 1;
		font-weight: bold;
		color: #666;
	}

	.detail-value {
		flex: 2;
		color: #333;
	}

	.status-badge {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 10px;
	}

	.status-badge.待处理 {
		color: #F56C6C;
	}

	.status-badge.处理中 {
		color: #E6A23C;
	}

	.status-badge.已完成 {
		color: #67C23A;
	}

	/* 附件部分样式 */
	.section-title {
		margin: 20px 0 10px;
		padding-left: 10px;
		border-left: 4px solid #409EFF;
	}

	.attachment-list {
		background: #fff;
		border-radius: 8px;
		padding: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.attachment-item {
		display: flex;
		align-items: center;
		padding: 10px 0;
		border-bottom: 1px solid #eee;
	}

	.attachment-item:last-child {
		border-bottom: none;
	}

	.file-icon {
		margin-right: 10px;
		color: #409EFF;
		font-size: 20px;
	}

	.file-name {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.download-btn {
		padding: 5px 10px;
		background-color: #67C23A;
		color: white;
		border: none;
		border-radius: 4px;
		font-size: 12px;
		cursor: pointer;
	}

	/* 处理记录样式 */
	.record-list {
		background: #fff;
		border-radius: 8px;
		padding: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.record-item {
		padding: 10px 0;
		border-bottom: 1px solid #eee;
	}

	.record-item:last-child {
		border-bottom: none;
	}

	.record-time {
		font-size: 12px;
		color: #999;
		margin-bottom: 5px;
	}

	.record-content {
		margin-bottom: 5px;
	}

	.record-operator {
		font-size: 12px;
		color: #409EFF;
		text-align: right;
	}

	/* 响应式调整 */
	@media (max-width: 480px) {
		.detail-row {
			flex-direction: column;
		}

		.detail-label {
			margin-bottom: 5px;
		}

		.code-input,
		.verify-btn {
			width: 60%;
		}

		.code-input {
			width: calc(60% - 30px);
		}

		.repair-detail {
			max-width: 100%;
			margin: 0 auto;
		}

	}
</style>